import * as React from 'react';
import './CatLoader.scss';

export function Loader() {
  return (
    <div className="rp-cat-loader">
      <div className="cat-loader" />
    </div>
  );
}
